import { SelectContent } from "./SelectContent";
import { SelectGroup } from "./SelectGroup";
import { SelectItem } from "./SelectItem";
import { SelectTrigger } from "./SelectTrigger";
import { SelectValue } from "./SelectValue";
import { SelectLabel } from "./SelectLabel";
import { SelectRoot } from "./SelectRoot";

const Root = SelectRoot;
const Content = SelectContent;
const Item = SelectItem;
const Group = SelectGroup;
const Trigger = SelectTrigger;
const Label = SelectLabel;
const Value = SelectValue;

export const Select: {
  Root: typeof SelectRoot;
  Content: typeof SelectContent;
  Item: typeof SelectItem;
  Group: typeof SelectGroup;
  Trigger: typeof SelectTrigger;
  Label: typeof SelectLabel;
  Value: typeof SelectValue;
} = {
  Root,
  Content,
  Item,
  Group,
  Trigger,
  Label,
  Value,
};
